import { resourcesCopy } from '@/copy/resources'
import { TextField } from '@/ui/Field/Field'
import { type FieldProps, type Fields, fieldStr } from './shared'

// eslint-disable-next-line react-refresh/only-export-components -- local component; the descriptor below is this file's only export
function SqliteFields({ fields, set }: FieldProps) {
  return (
    <TextField
      id="res-path"
      label={resourcesCopy.forms.sqlite.path}
      value={fields.path ?? ''}
      onValue={(v) => set('path', v)}
      inputProps={{ placeholder: resourcesCopy.forms.sqlite.pathPlaceholder }}
    />
  )
}

export const sqliteForm = {
  Fields: SqliteFields,
  toBody: (f: Fields) => ({ path: f.path ?? '' }),
  fromResource: (d: unknown) => ({ path: fieldStr(d, 'path') }),
}
